export enum UserRoles {
  SuperAdmin = "SUPER_ADMIN",
  CountryAdmin = "COUNTRY_ADMIN",
  Translator = "TRANSLATOR",
  User = "USER"
}
